/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Serie200,
  GetApiV1Serie401,
  GetApiV1Serie500,
  GetApiV1SerieQueryParams,
  GetApiV1SerieQueryResponse,
} from "../../types/serieRegistroController/GetApiV1Serie.ts";
import { eCompanyFilterTypeSchema } from "../eCompanyFilterTypeSchema.ts";
import { serieGridItemViewModelPaginatedResponseSchema } from "../serieGridItemViewModelPaginatedResponseSchema.ts";

export const getApiV1SerieQueryParamsSchema = z.object({
  filter: z.optional(
    z
      .lazy(() => eCompanyFilterTypeSchema)
      .describe("1 = Main | 2 = Company | 3 = All | "),
  ),
  companyId: z.optional(z.coerce.number().int()),
  search: z.optional(z.string()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1SerieQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Serie200Schema = z.lazy(
  () => serieGridItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Serie200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Serie401Schema =
  z.any() as unknown as ToZod<GetApiV1Serie401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Serie500Schema =
  z.any() as unknown as ToZod<GetApiV1Serie500>;

export const getApiV1SerieQueryResponseSchema = z.lazy(
  () => getApiV1Serie200Schema,
) as unknown as ToZod<GetApiV1SerieQueryResponse>;
